import { WebAudioSuper } from "./webaudio_super.js";

class WebAudioSound extends WebAudioSuper {
  namespace = "webaudio:sound";
}

const webAudioSound = new WebAudioSound();
export { webAudioSound, WebAudioSound };
